import constants from "../../constants";
import utils from "../../services/utils";
import vbIncomingDocUserViewService from "../../services/vbIncomingDocUserViewService";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import dateUtils from "../../dateUtils";
import h from "../../services/h";

export default {
  mixins: [vbAttachmentTokenMixin],

  data() {
    return {
      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
      perfectScrollbarSetting: {
        maxScrollbarLength: 350
      },
      sendTimeRange: null,
      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      incomingDocs: [],
      selectedDocId: null,
      page: 0,
      size: 10,
      advanceSearchForm: {},
      sort: null,
      order: null,
      keyword: null,
      filterStatus: null,
      docReadStatusFilter: null
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    filterStatusQuery() {
      return this.$route.query.filterStatus;
    }
  },

  watch: {
    isOpenAdvanceSearchDialog(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },
    filterStatusQuery(newValue) {
      if (
        (newValue || constants.VBDEN_CHOXULY_PAGE.FILTER.ALL) !==
        (this.filterStatus || constants.VBDEN_CHOXULY_PAGE.FILTER.ALL)
      ) {
        this.advanceSearchForm.filterStatus = this.filterStatus = newValue;
        this.doSearch();
      }
    }
  },

  // created() {
  //   this.initQuery();
  // },

  methods: {
    filterBySendTime(event) {
      this.advanceSearchForm.fromSendTime =
        this.sendTimeRange && this.sendTimeRange[0]
          ? this.sendTimeRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toSendTime =
        this.sendTimeRange && this.sendTimeRange[1]
          ? this.sendTimeRange[1].getTime()
          : undefined;
      this.doSearch();
    },

    initSendTimeRange() {
      if (
        this.advanceSearchForm.fromSendTime ||
        this.advanceSearchForm.toSendTime
      ) {
        this.sendTimeRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromSendTime),
          dateUtils.toMoment(this.advanceSearchForm.toSendTime)
        ];
      } else {
        this.sendTimeRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
        this.advanceSearchForm.fromSendTime = defaultTimeRange[0];
        this.advanceSearchForm.toSendTime = defaultTimeRange[1];
      }
    },

    textBold(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "text-bold";
      } else return "";
    },

    closeDialog() {
      this.isOpenDialogCreate = false;
    },

    isShowPriority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    createDocSuccess() {
      this.isOpenDialogCreate = false;
      this.doSearch();
    },

    filterByStatus(event) {
      this.advanceSearchForm.filterStatus = this.filterStatus =
        event.filterStatus;
      this.doSearch();
    },

    initQuery() {
      console.log(this.$route.query);
      this.advanceSearchForm = {
        filterStatus:
          this.$route.query.filterStatus ||
          constants.VBDEN_CHOXULY_PAGE.FILTER.ALL,
        fromDocDate: this.$route.query.fromDocDate
          ? parseInt(this.$route.query.fromDocDate)
          : undefined,
        toDocDate: this.$route.query.toDocDate
          ? parseInt(this.$route.query.toDocDate)
          : undefined,

        keyword: this.$route.query.keyword || undefined,

        docCode: this.$route.query.docCode || undefined,
        fileContent: this.$route.query.fileContent || undefined,
        outsidePublisherName:
          this.$route.query.outsidePublisherName || undefined,
        docTypeId: this.$route.query.docTypeId || undefined,
        quote: this.$route.query.quote || undefined,
        publisherId: this.$route.query.publisherId || undefined,
        receiveDeptId: this.$route.query.receiveDeptId || undefined,
        bookId: this.$route.query.bookId || undefined,
        toIncomingDate: this.$route.query.toIncomingDate
          ? parseInt(this.$route.query.toIncomingDate)
          : undefined,
        fromIncomingDate: this.$route.query.fromIncomingDate
          ? parseInt(this.$route.query.fromIncomingDate)
          : undefined,
        toSendTime: this.$route.query.toSendTime
          ? parseInt(this.$route.query.toSendTime)
          : undefined,
        fromSendTime: this.$route.query.fromSendTime
          ? parseInt(this.$route.query.fromSendTime)
          : undefined,
        isRead: this.$route.query.isRead
          ? parseInt(this.$route.query.isRead)
          : undefined
      };

      this.docReadStatusFilter = h.find(
        this.docReadStatusFilters,
        item =>
          item.id ===
          (this.advanceSearchForm.isRead === undefined
            ? null
            : this.advanceSearchForm.isRead)
      );
      this.keyword = this.advanceSearchForm.keyword;
      this.filterStatus = this.advanceSearchForm.filterStatus;
    },

    buildQuery() {
      return utils.merge(
        { sort: this.sort || "updateTime", order: this.order || "desc" },
        this.advanceSearchForm
      );
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.docCode = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.advanceSearchForm.outsidePublisherName = undefined;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.publisherId = undefined;
      this.advanceSearchForm.receiveDeptId = undefined;
      this.advanceSearchForm.toIncomingDate = undefined;
      this.advanceSearchForm.fromIncomingDate = undefined;
      // this.advanceSearchForm.toSendTime = undefined;
      // this.advanceSearchForm.fromSendTime = undefined;
      this.advanceSearchForm.bookId = undefined;
      this.doSearch();
    },

    advanceSearch_(event) {
      let advanceSearchForm = event.advanceSearchForm;
      // console.log(JSON.stringify(advanceSearchForm));
      this.advanceSearchForm.keyword = undefined;
      this.keyword = null;
      this.advanceSearchForm.fromDocDate =
        advanceSearchForm.fromDocDate || undefined;
      this.advanceSearchForm.toDocDate =
        advanceSearchForm.toDocDate || undefined;
      this.advanceSearchForm.docCode = advanceSearchForm.docCode || undefined;
      this.advanceSearchForm.fileContent =
        advanceSearchForm.fileContent || undefined;
      this.advanceSearchForm.outsidePublisherName =
        advanceSearchForm.outsidePublisherName || undefined;
      this.advanceSearchForm.docTypeId =
        advanceSearchForm.docTypeId || undefined;
      this.advanceSearchForm.bookId = advanceSearchForm.bookId || undefined;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.publisherId =
        advanceSearchForm.publisherId || undefined;
      this.advanceSearchForm.receiveDeptId =
        advanceSearchForm.receiveDeptId || undefined;
      this.advanceSearchForm.toIncomingDate =
        advanceSearchForm.toIncomingDate || undefined;
      this.advanceSearchForm.fromIncomingDate =
        advanceSearchForm.fromIncomingDate || undefined;
      this.advanceSearchForm.toSendTime =
        advanceSearchForm.toSendTime || undefined;
      this.advanceSearchForm.fromSendTime =
        advanceSearchForm.fromSendTime || undefined;
    },

    doSort(event) {
      let { sort, order } = utils.convertElTableSortEvent(event);
      this.sort = sort;
      this.order = order;
      this.doSearch();
    },

    doSearch() {
      // Tạm thời bỏ đi detail khi mà đổi trạng thái. Sau sẽ fix cẩn thận :))
      let newNameRoute = this.$router.history.current.name.replace("Detail", "");
      this.$router.replace({
        name: newNameRoute,
        params: this.$route.params,
        query: this.buildQuery()
      });
      this.incomingDocs = [];
      this.page = 0;
      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };
      let processType;
      switch (this.filterStatus) {
        case constants.VBDEN_CHOXULY_PAGE.FILTER.CHU_TRI:
          processType = constants.PROCESS_TYPE.CHUTRI;
          break;
        case constants.VBDEN_CHOXULY_PAGE.FILTER.PHOI_HOP:
          processType = constants.PROCESS_TYPE.PHOIHOP;
          break;
        case constants.VBDEN_CHOXULY_PAGE.FILTER.NHAN_DE_BIET:
          processType = constants.PROCESS_TYPE.NHANDEBIET;
          break;
        default:
          processType = null;
          break;
      }
      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        status: this.status,
        relationType: this.relationType,
        processType: processType,
        includeBcc: true
      });
      return vbIncomingDocUserViewService
        .findAllV2(advanceSearchForm, pageable)
        .then(response => {
          let items = response.data;
          items && this.incomingDocs.push(...items);
          return items;
        });
    },

    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPiority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/doc-in/vbDenMixin.js